import { Page } from '@/core/architecture'

import { RecommendCollectionsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * RecentViewedItems Page
 * Implemented as a practical sample.
 */
export const RecommendCollections: Page = () => {
  const { state, actions } = useViewModel()

  return <RecommendCollectionsTemplate state={state} {...actions} />
}
